export const BoxStyle = {
  mr: 1,
  width: "250px",
};

export const SimpleBoxStyle = {
  width: "170px",
};
